import Head from "next/head";
import Layout from "layout/Layout/index.js";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Image from "next/image";

function RefundPolicy() {
    const { t } = useTranslation(["common", "nav", "contracts"]);
    const router = useRouter();

    return (
        <Layout>
            <Head>
                <title>{t("common:refundPolicy")}</title>
                <meta name="description" content={t("common:refundPolicyMetaDesc")} />
                <meta property="og:title" content={t("common:refundPolicy")} key="title" />
                <meta property="og:description" content={t("common:refundPolicyMetaDesc")} key="description" />
            </Head>
            <div className="py-20 bg-makdosSecondaryGray">

                <div className="container px-5 py-2.5 mx-auto mb-4 bg-makdosYellow rounded-[4px] flex flex-col lg:flex-row items-center justify-center lg:justify-start text-center">
                    <Image
                        src={"/refundPolicyHeader.svg"}
                        width={150}
                        height={125}
                        alt={t("common:refundPolicyImageAlt")}
                        title={t("common:refundPolicyImageTitle")}
                    />
                    <h1 className="text-xl text-titleColor lg:text-[22px] lg:ml-4">
                        {t("common:refundPolicyMetaDesc")}
                    </h1>
                </div>

                <div className="container px-6 py-10 mx-auto bg-white rounded-md">
                    <div className="flex justify-center">
                        <span className="relative mb-8 text-4xl font-semibold text-after-shadow lg:text-5xl">{t("common:refundPolicy")}</span>
                    </div>

                    <div className={router.locale === "tr" ? "block" : "hidden"}>
                        <div className="col-md-12 terms">
                            <b>Makdos Bilişim Teknolojileri</b> müşterisi satın aldığı ürün veya
                            hizmetlerden ürün satış tarihinden itibaren 7 gün içerisinde hiç bir mazeret göstermeksizin iade
                            talebinde bulunabilir.
                            <br /><br />
                            Koşulsuz iade şartları sadece <b>yeni satın alınan web hosting paketleri</b> için
                            geçerlidir. VPS, VDS, Dedicated sunucu, Lisans, Domain (alan adı), SSL gibi ürün, hizmetler ve
                            yenileme ödemeleri iade kapsamının dışındadır.
                            <br /><br />
                            Müşterinin iade talebi olması durumunda bu talebini e-mail aracılığı ile
                            <b> Makdos Bilişim Teknolojileri</b> müşteri hizmetlerine bildirmekle
                            yükümlüdür.
                            <br /><br />
                            <b> Makdos Bilişim Teknolojileri</b> iadeyi havale, EFT, nakit veya
                            kredi kartı işleminin kısmi iadesi şeklinde gerçekleştirebilir. İade işlemlerinde iade
                            <b> Makdos Bilişim Teknolojileri</b>'nın belirlediği kaynağa, iade işlemi için gerekli masraf
                            düşüldükten sonra yapılacaktır.
                            <br /><br />
                            <div className="text-right"><b>Makdos Bilişim Teknolojileri</b></div>
                        </div>
                    </div>

                    <div className={router.locale === "tr" ? "hidden" : "block"}>
                        <div className="col-md-12">
                            Customers of <b>Makdos Bilişim Teknolojileri</b> can request a return of the purchased products or services within 7 days from the date of purchase without providing any excuses.
                            <br /><br />
                            The unconditional return conditions apply only to <b>newly purchased web hosting packages</b>. Products, services, and renewal payments for VPS, VDS, Dedicated servers, licenses, domains (domain names), SSL, and similar items are not eligible for refunds.
                            <br /><br />
                            In the event of a customer's return request, they are obliged to communicate this request to <b>Makdos Bilişim Teknolojileri</b> customer services via email.
                            <br /><br />
                            <b>Makdos Bilişim Teknolojileri</b> can process the return via bank transfer, EFT, cash, or partial refund of the credit card transaction. Refunds will be made to the source determined by <b>Makdos Bilişim Teknolojileri</b> after deducting the necessary expenses for the return process.
                            <br /><br />
                            <div className="text-right"><b>Makdos Bilişim Teknolojileri</b></div>
                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    );
}

export default RefundPolicy;

export const getServerSideProps = async ({ locale }) => {
    return {
        props: {
            ...await serverSideTranslations(locale, ["common", "nav", "contracts"])
        }
    };
};